export { default } from './B2BPostTemplate';
export * from './B2BPostTemplate.types';
